// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__381-L","name":"styles_name__3K5um","phone":"styles_phone__37i1J"};